import * as React from 'react';
export var LineComponent = function (props) {
    var classString = props.value.style === 'thick' ? 'thick-style' : 'thin-style';
    return (React.createElement("div", { className: 'component line-component', "data-component-type": 'line' },
        React.createElement("hr", { className: "" + classString })));
};
//# sourceMappingURL=line-component.comp.js.map